import { EventDrivenStore } from '@core/store';
import constants from './constants';

class BookingStore extends EventDrivenStore {
  constructor() {
    super('booking', {
      bookings: [],
      currentBooking: null,
      loading: false,
      error: null
    }, {
      useLocalStorage: true
    });
  }

  setupEvents() {
    // Fetch bookings
    this.on(constants.EVENTS.BOOKING.FETCH_MY_BOOKINGS, () => {
      this.updateState({ loading: true, error: null });
    });

    // Fetch success
    this.on(constants.EVENTS.BOOKING.FETCH_MY_BOOKINGS_SUCCESS, (bookings) => {
      this.updateState({
        bookings,
        loading: false
      });
    });

    // Fetch error
    this.on(constants.EVENTS.BOOKING.FETCH_MY_BOOKINGS_ERROR, (error) => {
      this.updateState({
        loading: false,
        error
      });
    });

    // Fetch detail success
    this.on(constants.EVENTS.BOOKING.FETCH_BOOKING_DETAIL_SUCCESS, (booking) => {
      this.updateState({
        currentBooking: booking
      });
    });

    // Cancel success
    this.on(constants.EVENTS.BOOKING.CANCEL_BOOKING_SUCCESS, (bookingId) => {
      const bookings = this.state.bookings.map(b => {
        if (b.id === bookingId) {
          return { ...b, status: 'cancelled' };
        }
        return b;
      });
      this.updateState({ bookings });
    });

    // Check-in success
    this.on(constants.EVENTS.BOOKING.CHECK_IN_SUCCESS, (bookingId) => {
      const bookings = this.state.bookings.map(b => {
        if (b.id === bookingId) {
          return { ...b, status: 'used', checkedIn: true };
        }
        return b;
      });
      this.updateState({ bookings });
    });
  }
}

export default BookingStore;
